export enum DataManagmentUploads {
  OVERRIDES = 'OVERRIDES',
  TAGS = 'TAGS',
  VENUE_TYPES = 'VENUE_TYPES',
  FORMAT_SIZES = 'FORMAT_SIZES',
}
